import { CATEGORY_OPTION_DEFAULT_TYPE } from './constants';

/**
 * Pure helpers for GDPR category option updates.
 * Always spread the existing option so unrelated properties are preserved.
 */

/**
 * @param {Array} options
 * @param {number} optionIndex
 * @param {string} field
 * @param {*} value
 * @returns {Array}
 */
export const updateCategoryOptionField = (options, optionIndex, field, value) => {
    return (options || []).map((option, index) => {
        if (index !== optionIndex) {
            return option;
        }

        return {
            ...option,
            [field]: value
        };
    });
};

/**
 * Apply several field updates to one option while preserving all other properties.
 *
 * @param {Array} options
 * @param {number} optionIndex
 * @param {Object} fields
 * @returns {Array}
 */
export const updateCategoryOptionFields = (options, optionIndex, fields) => {
    return (options || []).map((option, index) => {
        if (index !== optionIndex) {
            return option;
        }

        return {
            ...option,
            ...fields
        };
    });
};

/**
 * Default payload for a newly added category option.
 * Type is always checkbox — users cannot change it in the Designer.
 * The shared Designer injects its own `id` via `addQuestionOption`.
 *
 * @returns {{ title: string, type: string }}
 */
export const createEmptyCategoryOption = () => ({
    title: '',
    type: CATEGORY_OPTION_DEFAULT_TYPE
});

/**
 * Whether a reporting-deadline select value is one of the preset hours.
 *
 * @param {*} reportingDeadlineHours
 * @param {Array<{ value: number|string }>} deadlines
 * @returns {boolean}
 */
export const isPresetReportingDeadline = (reportingDeadlineHours, deadlines) => {
    return (deadlines || []).some((deadline) => {
        return deadline.value === parseInt(reportingDeadlineHours, 10);
    });
};
